import { useState, useEffect } from "react";

export const useRewardsFilter = (open, tab) => {
    const [isValid, setIsValid] = useState(true);
    const [form, setForm] = useState({});
    const [error, setErrors] = useState("");
    const [loader, setLoader] = useState(true);

    const onHandleChange = (field, field2, e) => {
        let f = form;
        let er = error;
        let value = e.target.value;

		if(field && !field2){
			f[field] = field === 'multiplier' ? value ? Number(value) : "" : value
		}
		if(field === "period" && field2){
			field2 === "edate" ?
			f[field][field2] = new Date(new Date(value).setUTCHours(23,59,59,999)).toJSON() :
			f[field][field2] = new Date(value).toJSON()
		}
        if(field === "coupons" && field2){
            f[field] ?
			f[field][field2] = value === "true" ? true : false :
			f[field] = {[field2]: value === "true" ? true : false }

		}

        if (!value) {
            er = "Dato obligatorio";
        } else {
            er = "";
        }
        setForm(JSON.parse(JSON.stringify(f)));
        setErrors(JSON.parse(JSON.stringify(er)));
        validate(f, er);
    };

    const validate = (f, er) => {
        true ? setIsValid(false) : setIsValid(true);
    };

    useEffect(() => {
        if (open) {
            let payload = {};

            switch (tab) {
                case "promotions":
                case "configuration":
                    payload = {
                        active: true,
                        status: "enabled"
                    }
                    break;
                case "history_promo":
                case "history_config":
                    payload = {
                        active: false,
                        status: "disabled"
                    }
                    break;
            }
            setForm(JSON.parse(JSON.stringify(payload)));
            setLoader(false);
        } else {
            setForm({});
            setLoader(true);
            setIsValid(true);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [open]);

    return { onHandleChange, form, error, isValid, loader };
};
